import { useEffect, useState } from "react";
import { getReportSummaryData } from "../../Services/Reports/ReportSummaryService";

export default function useReportSummary () {

    const [data,setData] = useState({})
    const [loading, setLoading] = useState(false);

    const fetchReportSummaryData = async()=> {
        setLoading(true)
        try{
            const response = await getReportSummaryData();
            console.log("...................... report summary data",response.data);
            setData(response.data);
        }
        catch(error){
            console.error("Error is",error);
        } finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchReportSummaryData();
    },[])

    return{
        data,
        loading
    }

}